import React, { useEffect, useState } from 'react'
import { getDiffTime } from 'lib/utils'
import moment from 'moment/moment'
import { LinearProgress, makeStyles } from '@material-ui/core'
import TimerIcon from '@material-ui/icons/Timer'
import { ERROR_COLORS, SUCCESS_COLORS } from 'asterX-UI'

const TimerDiffDate = ({
  date,
  standardMinutes,
  gap = 5,
  rootStyle,
  activeColor = SUCCESS_COLORS[600],
  loseColor = ERROR_COLORS[600]
}) => {
  const fontSize = rootStyle?.fontSize ? rootStyle?.fontSize : 14
  const useStyles = makeStyles(theme => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      fontSize: fontSize,
      fontWeight: 400,
      lineHeight: '20px',
      gap,
      ...rootStyle,
      color: state.isLoseTime ? loseColor : activeColor
    }
  }))
  const [state, setState] = useState({
    currentTime: null,
    isLoseTime: false
  })

  const classes = useStyles()

  const countDownDate = new Date().getTime()
  useEffect(() => {
    const interval = setInterval(() => {
      getTime()
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [countDownDate])

  const getTime = () => {
    const { days, hours, minutes, seconds, ms } = getDiffTime(date)
    const hh = hours?.toString()?.length > 1 ? hours : '0' + hours
    const mm = minutes?.toString()?.length > 1 ? minutes : '0' + minutes
    const ss = seconds?.toString()?.length > 1 ? seconds : '0' + seconds
    setState(prev => ({
      ...prev,
      isLoseTime:
        standardMinutes && moment.duration(ms).asMinutes() > standardMinutes,
      currentTime: `${days} д. ${hh}:${mm}:${ss}`
    }))
  }

  return (
    <div className={classes.root}>
      <TimerIcon style={{ fontSize: fontSize + 2 }} />
      {state.currentTime || <LinearProgress style={{ width: '100%' }} />}{' '}
    </div>
  )
}
export default TimerDiffDate
